import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import UserHeader from "../../components/UserStatus/UserHeader";
import SummaryTabContent from "../../components/UserStatus/SummaryTabContent";
import UserTabContent from "../../components/UserStatus/UserTabContent";
import ActionButtons from "../../components/UserStatus/ActionButtons";
import { Card } from "../../components/ui/card";
import {
  Tabs,
  TabsList,
  TabsTrigger
} from "../../components/ui/tabs";
import {
  fetchUserData,
  getAiResponse,
  fetchUserLatestIssues,
  fetchUserLastActivity,
  fetchUserAppUsage,
  fetchUserDevice,
  fetchUserRecentActivity,
} from '../../store/actions';

const UserStatus = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { id: userId } = useParams();
  const [activeTab, setActiveTab] = useState("summary");

  const searchParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);

  useEffect(() => {
    const tab = searchParams.get("tab");

    if (tab) {
      setActiveTab(tab);
    } else {
      handleTabChange("summary")
    }
  }, [searchParams, location.pathname, history]);

  const handleTabChange = (newTab) => {
    setActiveTab(newTab);

    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set("tab", newTab);

    history.replace({
      pathname: location.pathname,
      search: newSearchParams.toString()
    });
  };

  useEffect(() => {
    dispatch(fetchUserData(userId));
    dispatch(fetchUserDevice(userId));
    dispatch(fetchUserLastActivity(userId));
    dispatch(getAiResponse(userId, "userSummaryTab"));
    dispatch(fetchUserLatestIssues(userId));
    dispatch(fetchUserRecentActivity(userId));
    dispatch(fetchUserAppUsage(userId));
  }, []);

  return (
    <div className="px-4 sm:px-6 mx-auto py-6">
      <div className="mx-auto">
        {/* User header with action buttons */}
        <div className="mb-6">
          <Card className="p-6">
            <div className="flex flex-col gap-6 md:gap-8">
              {/* User information */}
              <UserHeader />
              
              {/* Action buttons - visually separated */}
              <div className="pt-2 border-t border-gray-100">
                <ActionButtons />
              </div>
            </div>
          </Card>
        </div>

        {/* Main content */}
        <div className="grid grid-cols-1 gap-6">
          {/* Main content area - tabs */}
          <div>
            <Tabs
              value={activeTab}
              onValueChange={handleTabChange}
              className="w-full"
            >
              <TabsList
                className="mb-4 w-full justify-start bg-gray-100 p-1"
              >
                <TabsTrigger
                  value="summary"
                  className="data-[state=active]:bg-white"
                >
                  Summary
                </TabsTrigger>
                <TabsTrigger
                  value="network"
                  className="data-[state=active]:bg-white"
                >
                  Network
                </TabsTrigger>
                <TabsTrigger
                  value="application"
                  className="data-[state=active]:bg-white"
                >
                  Applications
                </TabsTrigger>
                <TabsTrigger
                  value="device"
                  className="data-[state=active]:bg-white"
                >
                  Device
                </TabsTrigger>
                <TabsTrigger
                  value="issues"
                  className="data-[state=active]:bg-white"
                >
                  Issues
                </TabsTrigger>
              </TabsList>

              {/* Tab content */}
              <SummaryTabContent userId={userId} />
              <UserTabContent userId={userId} />
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserStatus;
